/**
 * ======================================
 * Mutation types for the auth module
 * ======================================
 *
 * The mutation types that are available
 * on the auth module.
 */

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_USERS = 'GET_USERS';
export const CLEAN_STORE = 'CLEAN_STORE';

export default {
  LOGIN,
  LOGOUT,
  UPDATE_USER,
  GET_USERS,
  CLEAN_STORE,
};
